/* eslint-disable */
<template>
  <section class="receipt-page">

    <!-- Loading -->
    <div v-if="loading" class="loading-state">
      <div class="spinner-border text-primary" style="width:3rem;height:3rem;"></div>
      <p class="mt-3 text-muted">Loading receipt...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="loading-state">
      <i class="fas fa-exclamation-circle fa-3x text-danger mb-3"></i>
      <p class="text-danger fw-bold">{{ error }}</p>
      <button @click="$router.push('/water_bill_landing')" class="btn-back">Back to Home</button>
    </div>

    <!-- Receipt -->
    <div v-else class="page-body">

      <!-- Page Header (not printed) -->
      <div class="page-header no-print">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Water Bill Payment</p>
            <h1 class="page-title">Payment Receipt</h1>
            <p class="page-subtitle">ජල බිල් ගෙවීම් රිසිට්පත</p>
          </div>
        </div>
        <div class="header-actions">
          <button @click="printReceipt" class="btn-print">
            <i class="fas fa-download me-2"></i>Download PDF
          </button>
          <button @click="$router.push('/water_bill_landing')" class="btn-back">
            <i class="fas fa-home me-2"></i>Back to Home
          </button>
        </div>
      </div>

      <!-- ══════════════ PRINTABLE RECEIPT ══════════════ -->
      <div id="water-bill-receipt" class="receipt-doc">

        <!-- Receipt Header -->
        <div class="receipt-header-card">
          <div class="receipt-top">
            <div class="receipt-org">
              <div class="org-badge">
                <i class="fas fa-water"></i>
              </div>
              <div>
                <p class="org-system">Local Government Online Payment Management System</p>
                <h2 class="org-name">{{ receipt.sabha.name || receipt.sabha.code }}</h2>
                <p class="org-address" v-if="receipt.sabha.address">{{ receipt.sabha.address }}</p>
                <div class="org-contact" v-if="receipt.sabha.contact || receipt.sabha.fax">
                  <span v-if="receipt.sabha.contact">Tel: {{ receipt.sabha.contact }}</span>
                  <span v-if="receipt.sabha.fax">Fax: {{ receipt.sabha.fax }}</span>
                </div>
              </div>
            </div>
            <div class="receipt-meta">
              <div class="invoice-number">
                <p class="inv-label">Invoice No.</p>
                <p class="inv-value">{{ receipt.invoiceNumber }}</p>
              </div>
              <div class="receipt-type-badge">Water Bill Receipt</div>
              <div class="paid-date mt-2">
                <p class="inv-label">Paid At</p>
                <p class="inv-date">{{ formatDateTime(receipt.paidAt) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Customer Details -->
        <div class="receipt-card">
          <div class="card-header">
            <div class="step-badge"><i class="fas fa-user"></i></div>
            <div>
              <h2 class="card-title">Customer Details</h2>
              <p class="card-desc">ගනුදෙනුකරුවාගේ තොරතුරු</p>
            </div>
          </div>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">Account Number</span>
              <span class="detail-value acct-val">{{ receipt.accountNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Customer Name</span>
              <span class="detail-value">{{ receipt.customerName }}</span>
            </div>
            <div class="detail-item" v-if="receipt.customerNic">
              <span class="detail-label">NIC</span>
              <span class="detail-value">{{ receipt.customerNic }}</span>
            </div>
            <div class="detail-item" v-if="receipt.contactNo">
              <span class="detail-label">Contact No.</span>
              <span class="detail-value">{{ receipt.contactNo }}</span>
            </div>
            <div class="detail-item full-width" v-if="receipt.customerAddress">
              <span class="detail-label">Address</span>
              <span class="detail-value">{{ receipt.customerAddress }}</span>
            </div>
          </div>
        </div>

        <!-- Payment Breakdown -->
        <div class="receipt-card">
          <div class="card-header">
            <div class="step-badge"><i class="fas fa-file-invoice-dollar"></i></div>
            <div>
              <h2 class="card-title">Payment Breakdown</h2>
              <p class="card-desc">ගෙවීම් විස්තරය — Pay Month: {{ receipt.paymonth }}</p>
            </div>
          </div>

          <div class="breakdown-table-wrap">
            <table class="breakdown-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th class="num-col">Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="receipt.breakdown.arrears > 0">
                  <td>Arrears <span class="sinhala">(හිඟ මුදල)</span></td>
                  <td class="num-col">{{ fmtMoney(receipt.breakdown.arrears) }}</td>
                </tr>
                <tr v-if="receipt.breakdown.fines > 0">
                  <td class="fine-col">Fines <span class="sinhala">(දඩ)</span></td>
                  <td class="num-col fine-col">{{ fmtMoney(receipt.breakdown.fines) }}</td>
                </tr>
                <tr v-if="receipt.breakdown.current > 0">
                  <td>Current Bill <span class="sinhala">(වත්මන් බිල්)</span></td>
                  <td class="num-col">{{ fmtMoney(receipt.breakdown.current) }}</td>
                </tr>
                <tr v-if="receipt.breakdown.excess > 0">
                  <td class="excess-col">Excess / Advance <span class="sinhala">(අතිරේක)</span></td>
                  <td class="num-col excess-col">{{ fmtMoney(receipt.breakdown.excess) }}</td>
                </tr>
                <tr class="totals-row">
                  <td><strong>Total Paid Amount</strong></td>
                  <td class="num-col"><strong>{{ fmtMoney(receipt.paymentAmount) }}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="summary-section">
            <div class="summary-row">
              <span>Total Paid</span>
              <span class="sum-val">Rs. {{ fmtMoney(receipt.paymentAmount) }}</span>
            </div>
            <div class="summary-row remaining-row">
              <span>Remaining Balance After Payment</span>
              <span class="sum-val remaining-val">Rs. {{ fmtMoney(receipt.remainingBalance) }}</span>
            </div>
          </div>
        </div>

        <!-- Footer note -->
        <div class="receipt-footer">
          <i class="fas fa-shield-alt me-2"></i>
          This is a computer-generated receipt. No signature required. &nbsp;|&nbsp;
          <i class="fas fa-sms me-1"></i> SMS confirmation sent to registered mobile.
        </div>

      </div>
      <!-- end #water-bill-receipt -->

      <!-- Action buttons (not printed) -->
      <div class="bottom-actions no-print">
        <button @click="printReceipt" class="btn-print-lg">
          <i class="fas fa-download me-2"></i>Download as PDF
        </button>
        <button @click="$router.push('/water_bill_landing')" class="btn-back-lg">
          <i class="fas fa-redo me-2"></i>Pay Another Bill
        </button>
      </div>

    </div>
  </section>
</template>


<script>
import axios from "axios";
import html2pdf from "html2pdf.js";

export default {
  name: "WaterBillReceipt",
  data() {
    return {
      loading: true,
      error: "",
      receipt: {
        invoiceNumber: "",
        accountNumber: "",
        customerName: "",
        customerNic: null,
        contactNo: null,
        customerAddress: null,
        paymentAmount: 0,
        remainingBalance: 0,
        paymonth: "",
        paidAt: null,
        sabha: { code: "", name: "", address: "", contact: "", fax: "" },
        breakdown: { arrears: 0, fines: 0, current: 0, excess: 0, items: [] }
      }
    };
  },
  async mounted() {
    const invoiceNumber = this.$route.params.invoiceNumber
      || this.$route.query.invoice
      || "";

    if (!invoiceNumber) {
      this.error = "Invoice number not found.";
      this.loading = false;
      return;
    }

    try {
      const res = await axios.get(
        `/water_bill/online-payment/receipt/${encodeURIComponent(invoiceNumber)}`
      );
      if (res?.data?.status === "success" && res.data.data) {
        this.receipt = res.data.data;
      } else {
        throw new Error(res?.data?.message || "Receipt not found.");
      }
    } catch (err) {
      this.error = err?.response?.data?.message || err?.message || "Could not load receipt.";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    fmtMoney(val) {
      return parseFloat(val || 0).toLocaleString("en-LK", {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    },
    formatDateTime(val) {
      if (!val) return "N/A";
      try {
        return new Date(val).toLocaleString("en-LK", {
          timeZone: "Asia/Colombo",
          year: "numeric", month: "short", day: "2-digit",
          hour: "2-digit", minute: "2-digit"
        });
      } catch { return String(val); }
    },
    printReceipt() {
      const element = document.getElementById("water-bill-receipt");
      html2pdf(element, {
        margin:   [8, 8, 8, 8],
        filename: `WaterBill-Receipt-${this.receipt.invoiceNumber}.pdf`,
        image:    { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF:    { unit: "mm", format: "a4", orientation: "portrait" }
      });
    }
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.receipt-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}

/* ── Loading ── */
.loading-state {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; min-height: 70vh; text-align: center;
}

/* ── Page Header ── */
.page-body { max-width: 900px; margin: 0 auto; }
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.2rem; }
.header-bar {
  width: 5px; min-height: 64px; border-radius: 99px;
  background: linear-gradient(180deg, #1a3c6e, #0d6efd); flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.1rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; color: #6b7280; margin: 0 0 0.2rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.page-subtitle { font-size: 1.2rem; color: #9a8070; margin: 0; }

.header-actions { display: flex; gap: 0.8rem; align-items: flex-start; flex-wrap: wrap; }
.btn-print {
  display: inline-flex; align-items: center;
  padding: 0.8rem 1.6rem; border: none; border-radius: 0.7rem;
  background: linear-gradient(135deg, #1a3c6e, #0d6efd);
  color: #fff; font-size: 1.2rem; font-weight: 600; cursor: pointer;
  box-shadow: 0 4px 14px rgba(13,110,253,0.25); transition: all 0.2s;
}
.btn-print:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(13,110,253,0.35); }
.btn-back {
  display: inline-flex; align-items: center;
  padding: 0.8rem 1.6rem; border: 1px solid #e5ddd5; border-radius: 0.7rem;
  background: #fff; color: #4a3028; font-size: 1.2rem; font-weight: 600; cursor: pointer;
  transition: all 0.2s;
}
.btn-back:hover { background: #faf8f6; }

/* ══ Receipt Document ══ */
.receipt-doc {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1rem; overflow: hidden;
  box-shadow: 0 2px 12px rgba(100,50,30,0.06);
}

/* ── Receipt Header ── */
.receipt-header-card { padding: 2rem 2.2rem; border-bottom: 2px solid #f0e6de; }
.receipt-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 2rem; flex-wrap: wrap; }
.receipt-org { display: flex; align-items: flex-start; gap: 1.2rem; }
.org-badge {
  width: 3.6rem; height: 3.6rem; border-radius: 0.8rem; flex-shrink: 0;
  background: linear-gradient(135deg, #1a3c6e, #0d6efd);
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 1.5rem;
}
.org-system  { font-size: 0.9rem; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: #6b7280; margin: 0 0 0.2rem; }
.org-name    { font-family: 'DM Serif Display', serif; font-size: 1.6rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.org-address { font-size: 1.15rem; color: #4a3028; margin: 0 0 0.2rem; }
.org-contact { display: flex; gap: 1.2rem; font-size: 1.1rem; color: #9a8070; margin: 0; }

.receipt-meta { text-align: right; display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem; }
.inv-label  { font-size: 1rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.07em; color: #6b7280; margin: 0; }
.inv-value  { font-family: 'DM Serif Display', serif; font-size: 1.6rem; color: #1a3c6e; margin: 0; }
.inv-date   { font-size: 1.1rem; color: #4a3028; font-weight: 500; margin: 0; }
.receipt-type-badge {
  display: inline-block; padding: 0.35rem 1rem;
  background: linear-gradient(135deg, #1a3c6e, #0d6efd);
  color: #fff; border-radius: 99px;
  font-size: 1.1rem; font-weight: 600;
}

/* ── Cards ── */
.receipt-card { padding: 1.8rem 2.2rem; border-bottom: 1px solid #f0e6de; }
.receipt-card:last-of-type { border-bottom: none; }
.card-header {
  display: flex; align-items: center; gap: 1.2rem;
  margin-bottom: 1.4rem; padding-bottom: 1.2rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.4rem; height: 3.4rem; border-radius: 50%;
  background: linear-gradient(135deg, #1a3c6e, #0d6efd);
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 1.3rem; flex-shrink: 0;
}
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.5rem; color: #1c0f0a; margin: 0 0 0.1rem; }
.card-desc  { font-size: 1.1rem; color: #9a8070; margin: 0; }

/* ── Detail Grid ── */
.detail-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; }
.detail-item {
  background: #faf8f6; border: 1px solid #f0e6de;
  border-radius: 0.6rem; padding: 0.9rem 1.1rem;
}
.detail-item.full-width { grid-column: 1 / -1; }
.detail-label { font-size: 1rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: #9a6652; display: block; margin-bottom: 0.2rem; }
.detail-value { font-size: 1.2rem; color: #1c0f0a; font-weight: 500; }
.acct-val { font-family: 'DM Serif Display', serif; font-size: 1.3rem; color: #1a3c6e; }

/* ── Breakdown Table ── */
.breakdown-table-wrap {
  overflow-x: auto; border: 1px solid #e5ddd5;
  border-radius: 0.7rem; margin-bottom: 1.2rem;
}
.breakdown-table { width: 100%; border-collapse: collapse; font-size: 1.2rem; }
.breakdown-table thead tr { background: #f0ebe3; }
.breakdown-table th {
  padding: 0.85rem 1rem; text-align: left;
  font-size: 1.05rem; font-weight: 700; color: #4a3028;
  text-transform: uppercase; letter-spacing: 0.04em;
  border-bottom: 2px solid #e5ddd5;
}
.breakdown-table td {
  padding: 0.8rem 1rem; color: #1c0f0a;
  border-bottom: 1px solid #f0ebe3; vertical-align: middle;
}
.breakdown-table tbody tr:last-child td { border-bottom: none; }
.breakdown-table tbody tr:hover { background: #fdf9f6; }
.num-col    { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.fine-col   { color: #b91c1c; }
.excess-col { color: #0369a1; }
.totals-row { background: #f0ebe3 !important; }
.totals-row td { font-size: 1.15rem; padding: 1rem; }
.sinhala { font-size: 0.9rem; color: #9a8070; margin-left: 4px; }

/* ── Summary ── */
.summary-section {
  border-top: 1px solid #f0e6de; padding-top: 1rem;
  display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem;
}
.summary-row {
  display: flex; justify-content: space-between; align-items: center;
  gap: 3rem; min-width: 26rem;
  font-size: 1.2rem; color: #4a3028;
}
.sum-val { font-weight: 700; color: #1c0f0a; font-variant-numeric: tabular-nums; }
.remaining-row {
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.6rem; padding: 0.7rem 1rem;
}
.remaining-val { color: #0f766e; font-size: 1.3rem; }

/* ── Footer ── */
.receipt-footer {
  padding: 1.2rem 2.2rem; background: #f9f7f5;
  font-size: 1.05rem; color: #9a8070; text-align: center;
  border-top: 1px solid #f0e6de;
}

/* ── Bottom Actions ── */
.bottom-actions {
  display: flex; gap: 1rem; margin-top: 2rem; justify-content: flex-end; flex-wrap: wrap;
}
.btn-print-lg {
  display: inline-flex; align-items: center; padding: 1rem 2.2rem;
  border: none; border-radius: 0.8rem;
  background: linear-gradient(135deg, #1a3c6e, #0d6efd);
  color: #fff; font-size: 1.3rem; font-weight: 700; cursor: pointer;
  box-shadow: 0 4px 16px rgba(13,110,253,0.25); transition: all 0.2s;
}
.btn-print-lg:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(13,110,253,0.35); }
.btn-back-lg {
  display: inline-flex; align-items: center; padding: 1rem 2.2rem;
  border: 1px solid #e5ddd5; border-radius: 0.8rem;
  background: #fff; color: #4a3028; font-size: 1.3rem; font-weight: 700; cursor: pointer;
  transition: all 0.2s;
}
.btn-back-lg:hover { background: #faf8f6; }

/* ── Print styles ── */
@media print {
  .no-print { display: none !important; }
  .receipt-page { padding: 0; background: #fff; }
  .receipt-doc { box-shadow: none; border: none; }
}

/* ── Responsive ── */
@media (max-width: 640px) {
  .receipt-page { padding: 1rem 0.8rem 3rem; }
  .receipt-header-card, .receipt-card { padding: 1.4rem; }
  .receipt-top { flex-direction: column; }
  .receipt-meta { text-align: left; align-items: flex-start; }
  .detail-grid { grid-template-columns: 1fr; }
  .summary-row { min-width: unset; width: 100%; }
  .bottom-actions { flex-direction: column; }
  .btn-print-lg, .btn-back-lg { width: 100%; justify-content: center; }
}
</style>
